import { render, staticRenderFns } from "./DeleteDressModal.vue?vue&type=template&id=1fdc65c0&scoped=true"
import script from "./DeleteDressModal.vue?vue&type=script&lang=js"
export * from "./DeleteDressModal.vue?vue&type=script&lang=js"
import style0 from "./DeleteDressModal.vue?vue&type=style&index=0&id=1fdc65c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fdc65c0",
  null
  
)

export default component.exports